// extracted by mini-css-extract-plugin
export default {"-large":"ys6N5hITYhoj2meIcqcQ","optionContainer":"FD3IUboq2hogBAkdZmyA","numGuestsTextContainer":"ybBhJj3ntz2PNBCYXq5L","registrationSection":"JUPWx6a_7MMDP4zVDeRQ"};